import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/pcs_logical_card_usage_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered). Sits one
// include segment off two live PCS chains (card-ops transactions,
// tas-features pcs-cards.pcs-authorizations) — highest-risk medium gap. All
// inverses null: the related schemas do not declare a pcsLogicalCardUsage field.
const PcsLogicalCardUsageSchema = withDefaults({
  type: 'pcs-logical-card-usage',
  fields: [
    { kind: 'attribute', name: 'decisioning' },
    { kind: 'attribute', name: 'deletedAt' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'pcsCard',
      type: 'pcs-card',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'pcsAuthorizations',
      type: 'pcs-authorization',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'pcsTransactions',
      type: 'pcs-transaction',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'pcsNetworkMerchants',
      type: 'pcs-network-merchant',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'tasAssistances',
      type: 'tas-assistance',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsLogicalCardUsageSchema;
